import type { FieldValues } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { InputAdornment, TextField } from '@mui/material';
import type { FieldBaseProps } from './types';

export interface FieldCurrencyProps<T extends FieldValues> extends FieldBaseProps<T> {
  placeholder?: string;
}

/**
 * RHF-bound USD amount field with a leading `$`. Money is USD-only (no currency
 * selector), per house style.
 */
export function FieldCurrency<T extends FieldValues>({
  control,
  name,
  label,
  helperText,
  required,
  disabled,
  placeholder = '0.00',
}: FieldCurrencyProps<T>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          size="small"
          value={field.value ?? ''}
          label={label}
          placeholder={placeholder}
          type="number"
          required={required}
          disabled={disabled}
          fullWidth
          error={!!fieldState.error}
          helperText={fieldState.error?.message ?? helperText}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">$</InputAdornment>,
            },
            htmlInput: { step: '0.01', min: 0, inputMode: 'decimal' },
          }}
        />
      )}
    />
  );
}
